module.exports = __webpack_public_path__ + "img/gift10.1d7efa05.png";